// UNCOMMENT LINES WHEN WE HAVE THE VIDEO LINK

import React, { useState } from 'react';
import { Button } from 'antd';
import Can from 'config/Can';
import { ONBOARDING_VIDEO_TOPICS } from 'constants/onboarding';
// import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import useTranslation from 'utils/hooks/useTranslation';
// import useAmplitude from 'utils/hooks/useAmplitude';
import VehiclesIcon from 'components/Shared/Icons/VehiclesIcon';
import EmptyState from 'components/Layout/EmptyState';
import HowToVideo from 'components/Shared/HowToVideo';

import styles from './style.module.scss';

const VehiclesEmptyState = ({ handleBulkUpload, handleAddVehicle, visible }) => {
  const { translateText } = useTranslation();
  // const { sendAmplitudeEvent } = useAmplitude();

  const [isVideoVisible, setIsVideoVisible] = useState(false);

  // const openHowToVideo = () => {
  //   setIsVideoVisible(true);
  //   sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.howToAddVehicleVideoOpened);
  // };

  if (!visible) return null;

  return (
    <>
      <EmptyState
        icon={<VehiclesIcon />}
        title={translateText('corporateAccounts.onboarding.addVehicleStep.title')}
        description={translateText('corporateAccounts.vehicles.emptyState.description')}
        buttons={
          <>
            <Can I="create" a="Vehicle" passThrough>
              {can => (
                <Button
                  type="primary"
                  size="large"
                  onClick={handleAddVehicle}
                  disabled={!can}
                  data-testid="addVehicleButton"
                >
                  {translateText('corporateAccounts.vehicles.actions.addVehicle')}
                </Button>
              )}
            </Can>
            <Can I="upload" a="Vehicle" passThrough>
              {can => (
                <Button
                  type="secondary"
                  size="large"
                  onClick={handleBulkUpload}
                  className={styles.button}
                  disabled={!can}
                  data-testid="bulkUploadVehiclesButton"
                >
                  {translateText('corporateAccounts.vehicles.emptyState.ImportVehiclesBtn')}
                </Button>
              )}
            </Can>
          </>
        }
        // videoLink={
        //   <span className={styles.buttonAsLink} onClick={openHowToVideo}>
        //     {translateText('corporateAccounts.vehicles.emptyState.videoLink')}
        //   </span>
        // }
      />
      <HowToVideo
        topic={ONBOARDING_VIDEO_TOPICS.HOW_TO_VEHICLES}
        title={translateText('corporateAccounts.vehicles.emptyState.videoLink')}
        isVisible={isVideoVisible}
        setIsVisible={setIsVideoVisible}
      />
    </>
  );
};

export default VehiclesEmptyState;
